module.exports = __webpack_public_path__ + "img/storehouse.55a59630.svg";